/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { useTranslation } from 'react-i18next';

import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import EnrichmentActivityChart from '../../charts/EnrichmentActivityChart';
import ReportCard from 'components/ReportsModule/components/common/ReportCard';
import { KeyClassroomEngagementStudentResult } from 'types/schema-generated-types';
import { ReportEntityType } from 'components/ReportsModule/types';

const ClassroomEnrichmentActivityChartCard: React.FC<{
  reportData: KeyClassroomEngagementStudentResult[];
  loading: boolean;
}> = ({ reportData = [], loading }) => {
  const { t } = useTranslation(['Reports', 'ReportsHelpCharts']);
  const [, setQuery] = useReportQueryParams();

  const {
    studentNames,
    ids,
    hearItTypeItCompletedSeries,
    myChoiceKeyboardingCompletedSeries
  } = reportData.reduce(
    (acc, { student, enrichmentActivities }) => {
      if (!student) return acc;
      const { studentNames, ...stats } = acc;

      studentNames.push(`${student.firstName} ${student.lastName}`);
      stats.ids.push(student.id);
      stats.hearItTypeItCompletedSeries.push(enrichmentActivities?.hearItTypeItCompletedCount ?? 0);
      stats.myChoiceKeyboardingCompletedSeries.push(
        enrichmentActivities?.myChoiceKeyboardingCompletedCount ?? 0
      );

      return acc;
    },
    {
      ids: [] as number[],
      studentNames: [] as string[],
      hearItTypeItCompletedSeries: [] as number[],
      myChoiceKeyboardingCompletedSeries: [] as number[]
    }
  );

  const handleChartClick = (index: number) => {
    setQuery({ entityType: ReportEntityType.STUDENT, entityId: ids[index] }, 'pushIn');
  };

  return (
    <ReportCard
      title={t('Enrichment Activities')}
      helpText={t('enrichmentActivities', { ns: 'ReportsHelpCharts' })}
      loading={loading}
      reportData={reportData}
      reportDataProp="enrichmentActivities"
    >
      <EnrichmentActivityChart
        hearItTypeItCompletedSeries={hearItTypeItCompletedSeries}
        myChoiceKeyboardingCompletedSeries={myChoiceKeyboardingCompletedSeries}
        labels={studentNames}
        onClick={handleChartClick}
      />
    </ReportCard>
  );
};

export default ClassroomEnrichmentActivityChartCard;
